export default __webpack_public_path__ + "static/avatar-example-d9f346716c95bcd49b3e25a731d42f14.webp";